import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./NASA.css";

import NASAImg from "../../works_images/works1.png";
import NASAImg1 from "../../works_images/works1.1.png";
import NASAImg2 from "../../works_images/works1.2.png";
import NASAImg3 from "../../works_images/works1.3.png";
import NASAImg4 from "../../works_images/works1.4.png";

const ArrowLeft = ({ className, style, onClick }) => (
  <div
    className={`${className} custom-arrow left`}
    style={{ ...style }}
    onClick={onClick}
  >
    <FaChevronLeft />
  </div>
);

const ArrowRight = ({ className, style, onClick }) => (
  <div
    className={`${className} custom-arrow right`}
    style={{ ...style }}
    onClick={onClick}
  >
    <FaChevronRight />
  </div>
);

const NASA = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");

  const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
  };

  const images = [
    { src: NASAImg, alt: "NASA Image Explorer screenshot 1" },
    { src: NASAImg1, alt: "NASA Image Explorer screenshot 2" },
    { src: NASAImg2, alt: "NASA Image Explorer screenshot 3" },
    { src: NASAImg3, alt: "NASA Image Explorer screenshot 4" },
    { src: NASAImg4, alt: "NASA Image Explorer screenshot 5" },
  ];

  return (
    <div className="project-page-container NASA-project">
      <div className="project-page-content">
        <button
          type="button"
          onClick={handleBack}
          className="back-button"
          aria-label="Back to Home"
        >
          &larr; Back to Home
        </button>

        <div className="project-header">
          <h1>NASA Image Explorer</h1>
          <p className="project-subtitle">
            An interactive, full-stack application for exploring NASA’s public
            image library.
          </p>
        </div>

        <div className="project-main-content">
          <div className="project-left-column">
            <h2>About The Project</h2>
            <p>
              The NASA Image Explorer is an interactive web application that
              brings the wonders of space to your fingertips. It connects to
              NASA's public image database, allowing users to search for any
              space-related term and view a gallery of stunning, high-resolution
              images. Users can create a personal account to save their favorite
              discoveries to a protected gallery. The admin interface includes a
              list of all registered users and their favorite images.
            </p>

            <h2>Technical Deep Dive</h2>
            <p>
              The application was created as a term project for {""}
              <strong>
                a Server-Side Web Development course at Boston University
              </strong>
              , and later updated for display. It is built with a secure
              client-server architecture. The frontend, developed with React and
              Vite, provides a responsive user interface. To protect user data
              and manage access, the frontend communicates with a dedicated
              Node.js backend server.
            </p>
            <p>
              The backend handles all business logic, including user
              registration, session-based authentication using Passport.js, and
              interactions with the MongoDB database. It exposes a RESTful API
              for all standard operations and a GraphQL endpoint for read-only
              queries. This architecture guarantees that sensitive operations,
              like fetching a user's private favorites or accessing the admin
              dashboard, are securely protected and require proper
              authentication. The backend is deployed on Render, the frontend on
              Netlify, and the database on MongoDB Atlas.
            </p>
          </div>

          <div className="project-right-column">
            <div className="project-image-container">
              <Slider {...settings}>
                {images.map((img, idx) => (
                  <div key={idx}>
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="project-image"
                    />
                  </div>
                ))}
              </Slider>
              <div className="project-buttons">
                <a
                  href="https://nasa-images-explorer.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-button"
                >
                  Website
                </a>
                <a
                  href="https://github.com/Taniatos/nasa_imgs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-button secondary"
                >
                  Code
                </a>
              </div>
            </div>
            <div className="project-technology-container">
              <h2>Technology used</h2>
              <ul>
                <li>
                  <strong>Frontend:</strong> React (Vite), JavaScript (ES6+),
                  CSS3, React Router
                </li>
                <li>
                  <strong>Backend:</strong> Node.js, Express.js, REST API,
                  GraphQL (read-only)
                </li>
                <li>
                  <strong>Database:</strong> MongoDB with Mongoose
                </li>
                <li>
                  <strong>Authentication:</strong> Passport.js, Express Session
                  with connect-mongo, bcrypt
                </li>
                <li>
                  <strong>Deployment:</strong> Netlify (Frontend), Render
                  (Backend), MongoDB Atlas (Database)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NASA;
